module.exports = __webpack_public_path__ + "components/weather-icon/static/nightmodrain@2-f971fe3edb0ef83825ecdc9739d452ea.png";